import Collapse from 'bootstrap.collapse';
import { debounce, fetch } from 'utils';

onLoad();

export function onLoad(context = document) {
    context.querySelectorAll('.shop-search-widget').forEach(search => {
        const dropdown = new Collapse(search.querySelector('.dropdown'), { toggle: false });

        search.querySelector('input').addEventListener('input', debounce(async e => {
            if (e.target.value.length >= 3) {
                const response = await fetch(`/api/shop-search?search=${e.target.value}&maxProductListings=${search.$data.parameters?.maxProductListings ?? ''}&maxCategories=${search.$data.parameters?.maxCategories ?? ''}&maxBrands=${search.$data.parameters?.maxBrands ?? ''}`, {
                    method: 'GET'
                });
                const data = await response.json();

                search.$data.productListings = data.productListings;
                search.$data.categories = data.categories;
                search.$data.brands = data.brands;

                // Make sure the data has been set before toggling the dropdown.
                search.$data.$nextTick(() => {
                    if (search.$data.productListings.length || search.$data.categories.length || search.$data.brands.length)
                        dropdown.show();
                    else
                        dropdown.hide();
                });
            } else
                dropdown.hide();
        }, 500));
    });
}